import styled from 'styled-components'
import React from 'react'
import { Link } from 'react-router-dom'

import Menu from './Menu'
import logo_white from '../img/UB_logotyp_2rader_cremevit_RGB.png'
import logo_grey from '../img/UB_logotyp_2rader_gra_RGB.png'
import { UIStore } from '../stores/UIStore'
import { colors } from '../variables'
import { Row, Container, Col, Visible, Hidden } from 'react-grid-system'
import { observer } from 'mobx-react'
import { MobileMenuItems } from './MenuItems'

const Header = observer(() => {
  return (
    <HeaderContainer>
      <Row style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <Col md={4}>
          <LogoHolder>
            <HeaderLogo>
              <Link to="/">
                <img
                  alt="Logo"
                  src={
                    UIStore.backgroundShade === colors.green
                      ? logo_white
                      : logo_grey
                  }
                  style={{ cursor: 'pointer' }}
                />
              </Link>
            </HeaderLogo>
          </LogoHolder>
        </Col>
        <Col md={8}>
          <Hidden md>
            <DesktopMenuHolder>
              <Menu />
            </DesktopMenuHolder>
          </Hidden>
        </Col>
      </Row>
      <Visible xs sm md>
        <MobileMenuButton
          onClick={() => UIStore.toggleMobileMenu(!UIStore.mobileMenuOpen)}
        >
          <div />
          <div />
          <div />
        </MobileMenuButton>
        <StyledMobileMenu open={UIStore.mobileMenuOpen}>
          <MobileMenuItems />
        </StyledMobileMenu>
      </Visible>
    </HeaderContainer>
  )
})

const HeaderContainer = styled(Container)`
  display: flex;
  position: relative;
`

const LogoHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 110px;

  @media (min-width: 769px) {
    position: relative;
    width: 220px;
  }
`

const HeaderLogo = styled.div`
  text-align: center;
  margin-top: 11px;

  @media (min-width: 769px) {
    margin: 0;
  }

  img {
    cursor: pointer;
    width: 100%;
  }
`

const DesktopMenuHolder = styled.div`
  width: 100vw;
  display: none;

  @media (min-width: 769px) {
    position: relative;
    max-width: 980px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0 auto;
  }
`

const MobileMenuButton = styled.div`
  position: absolute;
  top: 28px;
  right: 28px;
  height: 12px;
  width: 20px;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  z-index: 200;

  > div {
    background-color: #fff;
    height: 1px;
    width: 100%;
    position: absolute;

    &:first-child {
      top: 0px;
    }

    &:nth-child(1) {
      top: 6px;
    }

    &:nth-child(2) {
      top: 12px;
    }
  }
`

const StyledMobileMenu = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: ${({ open }: { open: boolean }) => (open ? 0 : '100vw')};
  background-color: ${({ bg }: { bg: string }) =>
    bg === colors.green ? colors.white : colors.green};
  transition: left 0.4s ease-in-out;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default Header
